// extracted by mini-css-extract-plugin
export default {"legend":"chartLegend__legend___ZSjZe","line":"chartLegend__line___sdOqm","axisLabel":"chartLegend__axisLabel___fPCFJ","additionalValue":"chartLegend__additionalValue___uS4PS"};